import {
  get,
  post,
  postParams,
  deletes,
  put
} from './axios.js'; //导入axios实例文件中方法;
import {
  encryptData
} from './cryptoService.js'; //导入加密方法;

const Api = {
  http: sessionStorage.getItem('http') ? sessionStorage.getItem('http') : '',
  login: '/api/rbac/user/login',
  getUser: '/api/rbac/user/get',
  getTenants: '/api/rbac/user/tenants',
  switchTenants: '/api/rbac/user/switch_tenant',
  home: '/api/fr/process_category/query',
  getLic: '/api/lic/sys/lic',
  design: '/api/kanban/category/get_design',
  getLine: '/api/factory/production_line/query',
  getOeeLine: '/api/oee/production_line/tree',
  getTemplateCategory: '/api/layeraudit/category/query',
  setting: '/api/settings/get',
  board: {
    andon_board_url: "/api/andon/dashboard/data_v",
    andon_hour_url: "/api/andon/dashboard/data_hour_v",
    lpa_board_url: "/api/layeraudit/dashboard/data_v",
    lpa_plan_year: "/api/layeraudit/dashboard/plan_years",
    lpa_job_plans: "/api/layeraudit/dashboard/job_plans",
    ehs_board_url: "/api/ehs/dashboard/data_v",
    ei_board_url: "/api/ei/dashboard/data_v",
    nok_board_url: "/api/nok/report/data_v",
    nok_check_category: "/api/nok/check_category/query",
    cpm_board: "/api/cpm/dashboard/board",
    cpm_list: "/api/cpm/change_point_instance/my_page",
    oee_board_url: "/api/oee/dashboard/data_v",
    oee_product: "/api/oee/dashboard/product_details",
    oee_monthly: "/api/oee/dashboard/monthly_product",
    oeeOutPutList: '/api/oee/dashboard/week_output',
    trackingList: '/api/oee/tracking_list/query',
    oeeWeekKPI: '/api/oee/dashboard/week_sign_kpi',
    sysLogo: "/api/settings/theme/query",
    sysBoard: "/api/settings/module/query",
    dynamicTable: '/api/fr/process_group/find_by_board/ff8080816266551c01626664c9050003',
    dynamicValue: '/api/fr/issue/status/ff8080816266551c01626664c9050003',
    tableInfo: '/api/fr/issue/page/1/10',
    issueDp: '/api/fr/issue/dp/',
    fr_response: "/api/fr/dashboard/response",
    fr_approve: "/api/fr/dashboard/approve_list",
    fr_register: "/api/fr/register_plan/create_plan",
    fr_send: "/api/fr/issue/fr_send",
    fr_datav: "/api/fr/dashboard/data_v",
    fr_source_v: "/api/fr/dashboard/data_source_v",
    fr_datav_a3_why: "/api/fr/dashboard/data_v_a3_5why",
    fr_dp_group: "/api/fr/dashboard/dp_group",
    fr_report_group: "/api/fr/dashboard/report_group",
    fr_d8Report: "/api/fr/dashboard/d8_report",
    fr_a3Report: "/api/fr/dashboard/a3_report",
    fr_whyReport: "/api/fr/dashboard/why_report",
    fr_issue_response: "/api/fr/issue/fr_response",
    fr_issue_reject: "/api/fr/issue/fr_reject",
    fr_issue_approve: "/api/fr/issue/fr_approve_ok",
    fr_approve_reject: "/api/fr/issue/fr_approve_reject",
    fr_next_date: "/api/fr/issue/change_next_date",
    fr_todo_list: "/api/fr/issue/change_todoList",
    fr_source_list: "/api/fr/source/query",
    fr_schedule_list: "/api/fr/schedule/all",
    fr_trackingList: '/api/fr/tracking_list/query',
    fr_rest_schedule: "/api/fr/schedule/refresh_status",
    fr_schedule_change: "/api/fr/schedule/change_status",
    fr_instance_view: "/api/fr/process_instance/get_process_view",
    fr_issue_view: "/api/fr/issue/preview",
    qplot_url: "/api/fr/dashboard/q_plot",
    process_url: "/api/fr/process_instance/get_by_process",
    issue_url: "/api/fr/issue/get/",
    lpa_plan_board: '/api/layeraudit/report/audit_plan_board',
    escalation_board: '/api/escalation/dashboard/data_v',
    qc_day_url: '/api/oee/mm/dashboard/qc_day',
    qc_month_url: '/api/oee/mm/dashboard/qc_month',
    add_qc_day_url: '/api/oee/quality_calendar/add_with_dashboard',
    sc_day_url: '/api/oee/mm/dashboard/sc_day',
    sc_month_url: '/api/oee/mm/dashboard/sc_month',
    add_sc_day_url: '/api/oee/safety_calendar/add_with_dashboard',
    register_plan: '/api/oee/register_plan/create_plan',
    register_plan: '/api/oee/register_plan/create_plan',
    oee_ftq_url: '/api/oee/dashboard/query_ftq_issue_top',
    oee_issue_url: '/api/oee/dashboard/query_oee_issue_top'
  },
  option: {
    oee_failure_code: '/api/oee/failure_code/query',
    org_dept: '/api/org/department/query',
    oee_item: '/api/oee/item/query',
    oee_product: '/api/oee/product/query',
    oee_shutdown_code: '/api/oee/shutdown_code/query',
    oee_device: '/api/oee/device/query',
    oee_ftq_failure_code: '/api/oee/ftq_failure_code/query',
  }
}

export default class service {
  static login = (userData, useRsa) => { // 登录;
    var data = Object.assign({}, userData);
    Api.http = data.http;
    if (useRsa) {
      data['password'] = encryptData(data['password']);
    }
    return post(`${data.http + Api.login}`, data);
  };

  static getLic = () => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.getLic}`);
  }

  static getSetting = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.setting}`, params);
  }

  static getDesign = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.design}`, params);
  }

  static getUser = () => { // 登录;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.getUser}`);
  };

  static getTenants = () => { //获取租户列表
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.getTenants}`);
  }

  static switchTenants = (params) => { //切换租户列表
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.switchTenants}`, params);
  }

  static listTree = (params) => { // 问题树;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.home}`, params);
  };
  //board;
  static getDynamicTable = () => { // 动态的表头数据;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.dynamicTable}`);
  };
  static getDynamicValue = () => { // 获取动态的表头对应的值;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.dynamicValue}`);
  };
  static getTableInfo = () => { // 获取固定的表格数据;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.tableInfo}`);
  };

  static getIssueDp = (key, params) => { // 获取表格数据;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.issueDp + key}`, params);
  };

  static getIssue = (key) => { // 获取Issue;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.issue_url + key}`);
  };

  static getProcess = (issue, process) => { // 获取Process;
    Api.http = sessionStorage.getItem('http');
    var params = "issueUUID=" + issue + '&processUUID=' + process;
    return get(`${Api.http + Api.board.process_url}?` + params);
  };

  static getResponse = (params) => { // 获取快反待响应;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_response}`, params);
  };

  static getApprove = (params) => { // 获取快反待批准;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_approve}`, params);
  };

  static getRegister = (params) => { // 获取快反签到;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_register}`, params);
  };

  static frDppGroup = (params) => { // 获取快反分段显示;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_dp_group}`, params);
  };

  static frReportGroup = (params) => { // 获取快反报表分段统计显示;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_report_group}`, params);
  };

  static d8Report = (params) => { // 获取快反8D详情;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_d8Report}`, params);
  };

  static a3Report = (params) => { // 获取快反A3详情;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_a3Report}`, params);
  };

  static whyReport = (params) => { // 获取快反Why详情;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_whyReport}`, params);
  };

  static frSend = (params) => { // 获取推送;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_send}`, params);
  };

  static frConfirmResponse = (params) => { // 待响应批准;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_issue_response}`, params);
  };

  static frConfirmReject = (params) => { // 待响应拒绝;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_issue_reject}`, params);
  };

  static frApprove = (params) => { //快反批准;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_issue_approve}`, params);
  };

  static frApproveReject = (params) => { //快反批准拒绝;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_approve_reject}`, params);
  };

  static getFrTrackingList(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_trackingList}?query=${params}`);
  }

  static getSchedule = () => { // 获取快反日程表;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_schedule_list}`);
  };

  static getIssueView(uuid) { // 获取快反详情;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_issue_view}?uuid=` + uuid);
  };

  static getInstanceView = (issue, process) => { // 获取快反实例;
    Api.http = sessionStorage.getItem('http');
    var params = "issueUUID=" + issue + '&processUUID=' + process;
    return get(`${Api.http + Api.board.fr_instance_view}?` + params);
  };

  static restSchedule = () => { // 刷新快反日程表;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_rest_schedule}`);
  };

  static changeSchedule = (params) => { // 更新日程表状态;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_schedule_change}`, params);
  };

  static changeNextDate = (params) => { // 更新下次汇报日期;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_next_date}`, params);
  };

  static changeTodoList = (params) => { // 更新待办事项;
    Api.http = sessionStorage.getItem('http');
    return postParams(`${Api.http + Api.board.fr_todo_list}`, params);
  };

  static getFrSource = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_source_list}`, params);
  }

  static getFrDataV = (params) => { // 获取快反视图;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_datav}`, params);
  };

   static getFrSourceDataV = (params) => { // 获取快反来源视图;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_source_v}`, params);
  };

  static getFrDatavA3Why = (params) => { // 获取快反视图;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.fr_datav_a3_why}`, params);
  };


  static getQplot = (params) => { // 获取质量Q图;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.qplot_url}`, params);
  };

  static loadData = (params) => { // 获取安灯data-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.andon_board_url}`, params);
  };

  static loadAndonHourData = (params) => { // 获取安灯 data-hour-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.andon_hour_url}`, params);
  };

  static getEscalation = () => { // 获取升级流程data-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.escalation_board}`);
  };

  static lpaData = (params) => { // 获取审核data-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.lpa_board_url}`, params);
  };

  static ehsData = () => { // 获取EHSdata-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.ehs_board_url}`);
  };

  static eiData = () => { // 获取Eidata-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.ei_board_url}`);
  };

  static nokData = (params) => { // 获取Nokdata-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.nok_board_url}`, params);
  };

  static nokCheckCategory = () => { // 获取Nokdata-v;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.nok_check_category}`);
  };


  static cpmBoard = () => {//获取变化点total
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.cpm_board}`);
  };

  static cpmList(params) {
    //获取变化点的数据。
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.cpm_list}?page=1&pageSize=100000&query=${params}`);
  }

  static loadTheme = () => { //获取logo
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.sysLogo}`);
  }

  static loadBoardTitle = (params) => { //获取看板名称
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.sysBoard}`, params);
  }

  static loadPlanBoard(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.lpa_plan_board}`, params);
  }

  static loadPlanYearList() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.lpa_plan_year}`);
  }

  static loadJobPlans(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.lpa_job_plans}`, params);
  }

  static loadProductLine() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.getLine}`);
  }

  static loadOeeProductLine() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.getOeeLine}`);
  }

  static loadTemplateCategory() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.getTemplateCategory}`);
  }

  static oeeData() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oee_board_url}`);
  }

  static oeeProduct(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oee_product}`, params);
  }

  static oeeMonthlyProduct(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oee_monthly}`, params);
  }

  static getOeeOutPutList() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oeeOutPutList}?source=kb`);
  }

  static getTrackingList(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.trackingList}?query=${params}`);
  }

  static oeeWeekKPI(params) {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oeeWeekKPI}`, params);
  }
  static getQcDay = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.qc_day_url}`, params);
  };
  static getQcMonth = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.qc_month_url}`, params);
  };
  static addQcDay = (params) => {
    Api.http = sessionStorage.getItem('http');
    return post(`${Api.http + Api.board.add_qc_day_url}`, params);
  }
  static getScDay = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.sc_day_url}`, params);
  };
  static getScMonth = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.sc_month_url}`, params);
  };
  static addScDay = (params) => {
    Api.http = sessionStorage.getItem('http');
    return post(`${Api.http + Api.board.add_sc_day_url}`, params);
  }

  static getOeeRegister = (params) => { // 获取OEE签到;
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.register_plan}`, params);
  };

  static oeeFtqTopList = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oee_ftq_url}`, params);
  }

  static oeeIssueTopList = (params) => {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.board.oee_issue_url}`, params);
  }

  static loadOeeDevice() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.oee_device}`);
  }

  static loadOeeProduct() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.oee_product}`);
  }

  static loadOeeItem() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.oee_item}`);
  }

  static loadOeeDownCode() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.oee_failure_code}`);
  }

  static loadOeeFtqDownCode() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.oee_ftq_failure_code}`);
  }

  static loadOeeDownType() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.oee_shutdown_code}`);
  }

  static loadOrgDept() {
    Api.http = sessionStorage.getItem('http');
    return get(`${Api.http + Api.option.org_dept}`);
  }

}



// WEBPACK FOOTER //
// ./src/utils/api.js